import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

let _2 = t => t,
    _t,
    _t2;

import PropTypes from 'prop-types';
import { Fragment, useEffect, useState } from 'react';
import { last } from 'ui-addon-upgrades/utils';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIImage from 'UIComponents/image/UIImage';
import UIIcon from 'UIComponents/icon/UIIcon';
import H3 from 'UIComponents/elements/headings/H3';
import UIScrollContainer from 'UIComponents/scroll/UIScrollContainer';
import H6 from 'UIComponents/elements/headings/H6';
import { GYPSUM, OLAF } from 'HubStyleTokens/colors';
import { ApiNameToFeaturesMap } from 'self-service-api/constants/ApiNameToFeaturesMap';
import FeaturesMap from 'self-service-api/constants/FeaturesMap';
import { getLangEligibleFeatureIds } from 'self-service-api/api/getLangEligibleFeatureIds';
import HubMap from 'self-service-api/constants/HubMap';
import ProductCatalogTableRow from 'ui-addon-upgrades/_core/productCatalog/ProductCatalogTableRow'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message

import ProductPageIcons from 'ui-addon-upgrades/_core/productPage/ProductPageIcons';
import FooterMicrocopy from 'ui-addon-upgrades/_core/common/components/FooterMicrocopy';
import breakpoint from '../utils/responsiveBreakpoints';
import { debounce } from '../../utils';
import partial from 'react-utils/partial';
import * as PurchaseTypes from 'self-service-api/constants/PurchaseTypes';
import ProductCatalogTableCell from './ProductCatalogTableCell';
import { productLineToHub } from 'self-service-api/constants/ProductLineToHub';
import { getAllEditionsForHub, getAllProductLevels, getCurrentFeatures, getFeaturesForProduct, getHighlightsForProductLine } from './utils';
import { AllProductLines } from 'self-service-api/constants/ProductLines';
import { FREE, STARTER, PROFESSIONAL, ENTERPRISE } from 'self-service-api/constants/ProductLevels';
const MODAL_WIDTH = 1200;
const HEADER_HEIGHT = 128;
const MODAL_TOP_MARGIN = 60;
const MODAL_BOTTOM_MARGIN = 47;
const HeaderSection = styled.div.withConfig({
  displayName: "ProductCatalogModal__HeaderSection",
  componentId: "dvtr2w-0"
})(["box-shadow:0 2px 4px 0 rgba(37,37,37,0.2);z-index:100;"]);
const ModalHeader = styled.div.withConfig({
  displayName: "ProductCatalogModal__ModalHeader",
  componentId: "dvtr2w-1"
})(["text-align:center;background-color:", ";padding:20px 0;& > h3{margin:0;}img{height:20px;}"], GYPSUM);
const TopHeaderCell = styled.th.withConfig({
  displayName: "ProductCatalogModal__TopHeaderCell",
  componentId: "dvtr2w-2"
})(["padding:20px;background-color:", ";height:50px;text-align:center;width:18.75%;min-width:175px;& > h6{margin:0;}:first-child{padding:0;width:2%;min-width:30px;}:nth-child(2){padding-left:0;width:25%;text-align:left;}"], OLAF);
const Table = styled.table.withConfig({
  displayName: "ProductCatalogModal__Table",
  componentId: "dvtr2w-3"
})(["border-spacing:0;width:100%;margin-bottom:0;"]);
const StyledTier = styled.div.withConfig({
  displayName: "ProductCatalogModal__StyledTier",
  componentId: "dvtr2w-4"
})(["display:none;width:90%;margin:0 auto;padding:2rem 0;text-align:center;button{font-size:0.75rem;cursor:pointer;padding:calc(1rem + 1px) 2rem;background:#fff;border:1px solid #7fd1de;flex-basis:25%;margin-right:-1px;text-align:center;transition:background-color 0.3s;&:hover{background-color:#e5f5f8;}&.active{font-weight:500;padding:1rem 2rem;border-width:2px;border-color:#00a4bd;background-color:#e5f5f8;}}button:first-child{border-radius:3px 0 0 3px;}button:last-child{border-radius:0 3px 3px 0;margin-right:0;}ul{display:none;list-style:none;padding:0;width:60%;margin:0 auto;text-align:left;li{font-size:16px;cursor:pointer;color:#0091ae;}}#tierToggle{position:absolute;top:-9999px;left:-9999px;}input[type='checkbox']:checked ~ label ~ ul{display:block;}", ";", ";"], breakpoint.tabletPortrait(_t || (_t = _2`
    display: flex;
  `)), breakpoint.phone(_t2 || (_t2 = _2`
    display: block;
    padding: 1rem 0;
  `)));
const TierSelected = styled.label.withConfig({
  displayName: "ProductCatalogModal__TierSelected",
  componentId: "dvtr2w-5"
})(["color:#0091ae;font-size:18px;font-weight:600;margin-right:3px;cursor:pointer;"]);

const TableRows = ({
  productLine,
  highlightedProducts,
  allProductLevels
}) => {
  const highestTierFeatures = last(highlightedProducts) ? ApiNameToFeaturesMap[last(highlightedProducts)] : {};
  const enterpriseFeatureIds = Object.keys(highestTierFeatures);
  const filteredEnterpriseFeatureIds = getLangEligibleFeatureIds(enterpriseFeatureIds);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: filteredEnterpriseFeatureIds.map(featureId => /*#__PURE__*/_jsx(ProductCatalogTableRow, {
      featureId: featureId,
      productLine: productLine,
      freeUserAccess: FeaturesMap[featureId] && HubMap[productLineToHub[productLine]].merchPurchaseType === PurchaseTypes.SEAT_BASED && FeaturesMap[featureId].freeUser || undefined,
      children: highlightedProducts.map((product, index) => {
        const features = getFeaturesForProduct(product, productLine);
        const currentProductLevel = allProductLevels[index];
        const hasFeature = features ? !!features[featureId] : false;
        return /*#__PURE__*/_jsx(ProductCatalogTableCell, {
          featureId: featureId,
          productLine: productLine,
          hasFeature: hasFeature,
          currentProductLevel: currentProductLevel,
          allProductLevels: allProductLevels
        }, product);
      })
    }, featureId))
  });
};

const MobileTableRows = ({
  productLine,
  activeColumn,
  currentProductLevel
}) => {
  const currentFeatures = getCurrentFeatures({
    productLine,
    activeColumn
  });
  const highlights = getHighlightsForProductLine(productLine);
  const featureIds = Object.keys(currentFeatures);
  const filteredFeatureIds = getLangEligibleFeatureIds(featureIds);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: filteredFeatureIds.map((featureId, i) => {
      // TODO Hiding the tooltips on mobile for now since they jump off the screen.
      //  Will probably need a different solution to better present the extra info on mobile
      return /*#__PURE__*/_jsx(ProductCatalogTableRow, {
        featureId: featureId,
        freeUserAccess: FeaturesMap[featureId] && HubMap[productLineToHub[productLine]].merchPurchaseType === PurchaseTypes.SEAT_BASED && FeaturesMap[featureId].freeUser || undefined,
        showTooltip: false,
        productLine: productLine,
        children: highlights.map((_, j) => {
          if (j === activeColumn) {
            return /*#__PURE__*/_jsx(ProductCatalogTableCell, {
              featureId: featureId,
              productLine: productLine,
              showTooltip: false,
              hasFeature: true,
              currentProductLevel: currentProductLevel
            }, j);
          }

          return null;
        })
      }, i);
    })
  });
};

const TableHeader = ({
  headerKeys
}) => {
  return /*#__PURE__*/_jsx(Table, {
    children: /*#__PURE__*/_jsx("thead", {
      children: /*#__PURE__*/_jsxs("tr", {
        children: [/*#__PURE__*/_jsx(TopHeaderCell, {}), headerKeys.map((headerKey, i) => /*#__PURE__*/_jsx(TopHeaderCell, {
          "data-key": i - 1,
          children: /*#__PURE__*/_jsx(H6, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `upgrades.productCatalog.tableHeader.${headerKey}`
            })
          })
        }, i))]
      })
    })
  });
};

const MobileTableHeader = ({
  activeColumn,
  headerKeys
}) => /*#__PURE__*/_jsx(Table, {
  children: /*#__PURE__*/_jsx("thead", {
    children: /*#__PURE__*/_jsxs("tr", {
      children: [/*#__PURE__*/_jsx("th", {}), headerKeys.map((headerKey, i) => {
        if (i === 0 || i - 1 === activeColumn) {
          return /*#__PURE__*/_jsx(TopHeaderCell, {
            "data-key": i - 1,
            children: /*#__PURE__*/_jsx(H6, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `upgrades.productCatalog.tableHeader.${headerKey}`
              })
            })
          }, i);
        }

        return null;
      })]
    })
  })
});

const TierSelector = ({
  activeColumn,
  headerKeys,
  setActiveColumn
}) => /*#__PURE__*/_jsx(StyledTier, {
  children: headerKeys.slice(1).map((headerKey, i) => /*#__PURE__*/_jsx("button", {
    onClick: partial(setActiveColumn, i),
    className: activeColumn === i ? 'active' : '',
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `upgrades.productCatalog.tableHeader.${headerKey}`
    })
  }, i))
});

const MobileTierSelector = ({
  activeColumn,
  headerKeys,
  setActiveColumn
}) => /*#__PURE__*/_jsxs(StyledTier, {
  children: [/*#__PURE__*/_jsx("input", {
    type: "checkbox",
    id: "tierToggle"
  }), /*#__PURE__*/_jsx(TierSelected, {
    htmlFor: "tierToggle",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `upgrades.productCatalog.tableHeader.${headerKeys.slice(1)[activeColumn]}`
    })
  }), /*#__PURE__*/_jsx(UIIcon, {
    name: "downCarat",
    size: 12
  }), /*#__PURE__*/_jsx("ul", {
    children: headerKeys.slice(1).map((headerKey, i) => /*#__PURE__*/_jsx("li", {
      onClick: () => setActiveColumn(i),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `upgrades.productCatalog.tableHeader.${headerKey}`
      })
    }, i))
  })]
});

const ProductCatalogModal = ({
  productLine,
  defaultProductLevel,
  onCloseClick,
  productMap
}) => {
  const [width, setWidth] = useState(window.innerWidth);
  const headerKeys = ['features', ...getAllEditionsForHub({
    productMap,
    productLine
  })];

  const getDefaultColumnIndex = () => {
    const productLevelIndex = defaultProductLevel ? headerKeys.slice(1).indexOf(defaultProductLevel.toLowerCase()) : 0;
    return Math.max(0, productLevelIndex);
  };

  const [activeColumn, setActiveColumn] = useState(getDefaultColumnIndex());
  useEffect(() => {
    const resizeWindow = debounce(() => setWidth(window.innerWidth), 250);
    window.addEventListener('resize', resizeWindow);
    return () => window.removeEventListener('resize', resizeWindow);
  }, []);
  const highlightedProducts = getHighlightsForProductLine(productLine);
  const hubName = productLineToHub[productLine];
  const allProductLevels = getAllProductLevels({
    productMap,
    productLine
  });
  const currentProductLevel = allProductLevels[activeColumn];
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "conversational",
    width: MODAL_WIDTH,
    style: {
      overflow: 'hidden'
    },
    "data-selenium-id": `product-catalog-${hubName}`,
    children: [/*#__PURE__*/_jsx(HeaderSection, {
      children: /*#__PURE__*/_jsxs(ModalHeader, {
        children: [/*#__PURE__*/_jsx(UIImage, {
          className: "display-inline m-right-2 m-bottom-2",
          src: ProductPageIcons[hubName]
        }), /*#__PURE__*/_jsx(H3, {
          className: "display-inline",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `pricing-pages.hubs.${hubName}.name`
          })
        }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
          onClick: onCloseClick,
          "data-selenium-id": `product-catalog-close-${hubName}`
        })]
      })
    }), /*#__PURE__*/_jsxs(Fragment, {
      children: [width <= 500 ? /*#__PURE__*/_jsx(MobileTierSelector, {
        headerKeys: headerKeys,
        activeColumn: activeColumn,
        setActiveColumn: setActiveColumn
      }) : /*#__PURE__*/_jsx(TierSelector, {
        activeColumn: activeColumn,
        headerKeys: headerKeys,
        setActiveColumn: setActiveColumn
      }), /*#__PURE__*/_jsxs("div", {
        children: [width <= 800 ? /*#__PURE__*/_jsx(MobileTableHeader, {
          headerKeys: headerKeys,
          activeColumn: activeColumn
        }) : /*#__PURE__*/_jsx(TableHeader, {
          headerKeys: headerKeys
        }), /*#__PURE__*/_jsxs(UIScrollContainer, {
          maxHeight: `calc(100vh - ${HEADER_HEIGHT + MODAL_TOP_MARGIN + MODAL_BOTTOM_MARGIN}px)`,
          scrollDirection: "vertical",
          children: [/*#__PURE__*/_jsx(Table, {
            children: /*#__PURE__*/_jsx("tbody", {
              children: width <= 800 ? /*#__PURE__*/_jsx(MobileTableRows, {
                activeColumn: activeColumn,
                productLine: productLine,
                currentProductLevel: currentProductLevel
              }) : /*#__PURE__*/_jsx(TableRows, {
                productLine: productLine,
                highlightedProducts: highlightedProducts,
                allProductLevels: allProductLevels
              })
            })
          }), /*#__PURE__*/_jsx(FooterMicrocopy, {})]
        })]
      })]
    })]
  });
};

ProductCatalogModal.propTypes = {
  productLine: PropTypes.oneOf(AllProductLines).isRequired,
  defaultProductLevel: PropTypes.oneOf(Object.values({
    FREE,
    STARTER,
    PROFESSIONAL,
    ENTERPRISE
  })),
  productMap: PropTypes.object,
  onCloseClick: PropTypes.func.isRequired
};
export default ProductCatalogModal;